core.directive('esIntegerValidator', function () {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$parsers.push(function (value) {
                var value = parseInt(value || '');
                ctrl.$setValidity('number', value === value);
                return value;
            });
        }
    };
});